<template>
  <div class="flex flex-col p-3 w-full">
    <span class="text-h6 text-[#17485D]">{{ label }}</span>
    <span class="text-body-2 text-[#206683]">{{ timestamp || '–' }}</span>
    <div class="p-4 bg-[#F3F4F7] rounded-md mt-2 flex justify-center items-center">
      <span class="value text-[#17485D]">{{ value }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string
  value: string
  timestamp: string
}>()
</script>

<style scoped>
.value {
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
</style>
